import { useState } from 'react'
import { Platform, StyleSheet } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import { HeaderBackOptions, Loader, PressableOpacity, Text, theme } from '@vatom/wombo'
import { BarCodeScanner } from 'expo-barcode-scanner'
import { BarCodeScanningResult, Camera, CameraType, FlashMode } from 'expo-camera'
import { Box } from 'native-base'
import { useThrottledCallback } from 'use-debounce'

import { HeaderButtonClose } from '../../../components/ScreenHeader'
import useCameraPermission from '../../../hooks/useCameraPermission'
import ScanOutline from '../ScanOutline'

interface ICameraScanner {
  onClose: () => void
  onScanner: (data: BarCodeScanningResult) => void
}

export const CameraScanner = ({ onClose, onScanner }: ICameraScanner) => {
  const { permission, isLoading } = useCameraPermission()
  const [torch, setTorch] = useState(false)

  const handleOnScanner = useThrottledCallback(onScanner, 500)

  return (
    <Box
      h="100%"
      maxW={Platform.OS === 'web' ? '600px' : '100%'}
      margin={Platform.OS === 'web' ? 'auto' : 0}
      borderRadius={10}
    >
      {permission?.granted ? (
        <Box
          style={{
            ...StyleSheet.absoluteFillObject,
            borderRadius: 10,
            overflow: 'hidden'
          }}
        >
          <Camera
            flashMode={torch ? FlashMode.torch : FlashMode.off}
            barCodeScannerSettings={{
              barCodeTypes: [
                BarCodeScanner.Constants.BarCodeType.qr,
                BarCodeScanner.Constants.BarCodeType.code128,
                BarCodeScanner.Constants.BarCodeType.code39,
                BarCodeScanner.Constants.BarCodeType.code93
              ]
            }}
            onBarCodeScanned={handleOnScanner}
            style={{
              flex: 1
            }}
            type={CameraType.back}
          />
        </Box>
      ) : null}

      {!isLoading ? (
        <Box zIndex="10" flex={1} justifyContent="center" alignItems="center">
          <Box
            zIndex={10}
            position="absolute"
            top="0"
            w="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Box alignSelf="flex-start">
              <HeaderBackOptions
                closeIcon={
                  <Box left={3} top={4}>
                    <Box
                      backgroundColor={'rgba(0,0,0,.5)'}
                      borderRadius={'99'}
                      alignItems={'center'}
                      justifyContent={'center'}
                      height={10}
                      width={10}
                    >
                      <HeaderButtonClose
                        color={
                          permission && permission.granted ? theme.colors.white : theme.colors.black
                        }
                      />
                    </Box>
                  </Box>
                }
                showOptions={false}
                onClose={onClose}
                color={permission && permission.granted ? theme.colors.white : theme.colors.black}
              />
            </Box>

            <Box background="rgba(0,0,0,0.5)" w="50%" borderRadius="10">
              <Text textAlign="center" p="2" color="#FFFFFF" tx="actionSheets.scanCode" />
            </Box>
          </Box>

          <Box flex="1" justifyContent="center" alignItems="center" zIndex={9}>
            <ScanOutline />
          </Box>

          {Platform.OS !== 'web' && (
            <Box
              h="250"
              position="absolute"
              bottom={0}
              w="100%"
              justifyContent="center"
              alignItems="center"
              zIndex={10}
            >
              <PressableOpacity
                // enable?: boolean, brightness?: number
                onPress={() => setTorch(!torch)}
                background={torch ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.5)'}
                h="70"
                w="70"
                borderRadius="35"
                justifyContent="center"
                alignItems="center"
              >
                <Ionicons name="flashlight-outline" size={40} color={torch ? 'black' : 'white'} />
              </PressableOpacity>
            </Box>
          )}
        </Box>
      ) : (
        <Loader />
      )}
    </Box>
  )
}
